import { render, staticRenderFns } from "./TodoFollowupWithTodo.vue?vue&type=template&id=30ecc79a"
import script from "./TodoFollowupWithTodo.vue?vue&type=script&lang=ts"
export * from "./TodoFollowupWithTodo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports